import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a standing floor lamp: a round matte-black base, a slim pole
// and a fabric drum shade with a glow-tone underside disc.
const BLACK = "#2e2e30";
const FABRIC = "#e8e0d2";
const GLOW = "#f5e9c8";

const SHADE_TOP = 1.62;
const SHADE_H = 0.26;

export const floorLamp = defineModel({
  id: "floor-lamp",
  batchId: "modern",
  name: "Floor lamp",
  tags: ["modern", "interior", "fixture", "lighting", "living-room"],
  summary: "A slim standing floor lamp with a fabric drum shade.",
  tiles: { w: 1, h: 1 },
  footprint: 0.6,
  parts(): Part[] {
    return [
      // Round base.
      { geometry: new THREE.CylinderGeometry(0.15, 0.16, 0.03, 14), color: BLACK,
        position: [0, 0.015, 0] },
      // Slim pole.
      { geometry: new THREE.CylinderGeometry(0.015, 0.015, SHADE_TOP - 0.03, 8), color: BLACK,
        position: [0, 0.03 + (SHADE_TOP - 0.03) / 2, 0] },
      // Fabric drum shade.
      { geometry: new THREE.CylinderGeometry(0.16, 0.16, SHADE_H, 14), color: FABRIC,
        position: [0, SHADE_TOP - SHADE_H / 2, 0] },
      // Glow-tone underside disc.
      { geometry: new THREE.CylinderGeometry(0.13, 0.13, 0.02, 14), color: GLOW,
        position: [0, SHADE_TOP - SHADE_H - 0.005, 0] },
    ];
  },
  animations: [],
});
